import { render, staticRenderFns } from "./vue-webRTC.vue?vue&type=template&id=07172618&scoped=true&"
import script from "./vue-webRTC.vue?vue&type=script&lang=js&"
export * from "./vue-webRTC.vue?vue&type=script&lang=js&"
import style0 from "./vue-webRTC.vue?vue&type=style&index=0&id=07172618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07172618",
  null
  
)

export default component.exports